import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import KubeTableActions from '@/components/kube/KubeTableActions.vue';
import type { Kube } from '@/types';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export const columns: ColumnDef<Kube>[] = [
    {
        accessorKey: 'name',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'kube.table.name',
            }),
    },
    {
        accessorKey: 'number',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'kube.table.number',
            }),
        meta: {
            filterType: 'number',
        },
    },
    {
        id: 'actions',
        enableHiding: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'tables.actions',
            }),
        cell: ({ row }) => {
            return h(KubeTableActions, {
                kube: row.original,
            });
        },
    },
];
